// Shared budget-band labels for the standard 6-band system used across
// Style / Cologne / Grooming / Skincare. Keep this in sync with the
// `BUDGET_BAND_OPTIONS` constants in profile + grooming + fragrance screens.

export const BUDGET_BAND_LABELS = {
  "under-50": "Under $50",
  "50-plus":  "$50+",
  "100-plus": "$100+",
  "250-plus": "$250+",
  "500-plus": "$500+",
  "luxury":   "Luxury · No budget",
};

export function budgetBandLabel(band) {
  if (!band) return "";
  // Map common legacy values seen in older docs to the new bands so we never
  // surface raw "drugstore" / "mid" / "$$$" to users.
  const k = String(band).trim().toLowerCase();
  if (BUDGET_BAND_LABELS[k]) return BUDGET_BAND_LABELS[k];
  if (k === "drugstore" || k === "$" || k === "budget")     return BUDGET_BAND_LABELS["under-50"];
  if (k === "mid" || k === "$$" || k === "designer")        return BUDGET_BAND_LABELS["100-plus"];
  if (k === "premium" || k === "$$$" || k === "high-end")   return BUDGET_BAND_LABELS["250-plus"];
  if (k === "$$$$" || k === "niche")                        return BUDGET_BAND_LABELS["500-plus"];
  return band; // unknown — render as-is so we can spot it in QA
}
